import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import ImageIcon from '@material-ui/icons/Image';
import EyeIcon from '@material-ui/icons/RemoveRedEye';
import DeleteIcon from '@material-ui/icons/Delete';

import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import ContentBox from 'components/CncUI/ContentBox';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  fileIcon: {
    width: 40,
  },
  fileName: {
    marginBottom: -8,
    [breakpoints.only('xs')]: {
      maxWidth: 200,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  },
  uploading: {
    color: palette.cncUI.default.primary,
  },
  error: {
    color: palette.cncUI.alert.red.primary,
  },
  controls: {
    '& .MuiGrid-item': {
      padding: '0 4px',
    },
    '& .MuiSvgIcon-root': {
      cursor: 'pointer',
    },
  },
}));

const SupportingDocumentUploadedFile = props => {
  const classes = useStyles();
  const { document, removeFileHandler, previewFileHandler } = props;
  const { state, file } = document;

  return (
    <ContentBox key={file.name}>
      <Grid container spacing={2} alignItems="center">
        <Grid item className={classes.fileIcon}>
          <ImageIcon />
        </Grid>
        <Grid item xs={8}>
          <Grid container spacing={0}>
            <Grid item>
              <Typography
                variant="body1"
                size="short"
                className={classes.fileName}
              >
                {file.name}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                italic
                variant="caption"
                className={clsx(
                  state === 'LOADING' && classes.uploading,
                  state === 'ERROR' && classes.error,
                )}
              >
                {state === 'SUCCESS'
                  ? `${file.size / 1000} kb`
                  : state === 'ERROR'
                  ? 'There was a problem uploading this file.'
                  : 'uploading...'}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {state !== 'LOADING' && (
          <Grid item xs>
            <Grid
              container
              spacing={2}
              justify="flex-end"
              className={classes.controls}
            >
              {state === 'SUCCESS' && (
                <Grid item>
                  <EyeIcon
                    onClick={() =>
                      previewFileHandler({
                        fileId: document.myFile.id,
                        fileName: file.name,
                      })
                    }
                  />
                </Grid>
              )}
              <Grid item>
                <DeleteIcon onClick={() => removeFileHandler(file.name)} />
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </ContentBox>
  );
};
export default SupportingDocumentUploadedFile;
